import { UserService } from 'src/app/_services/user.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { GlobalService } from 'src/app/_services/global.service';
import { BusinessSetupService } from 'src/app/_services/business-setup.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { usTimeZoneList } from 'src/app/_data/time-zones';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { LocationsService } from 'src/app/_services/locations.service';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
@Component({
    selector: 'app-theme-configuration',
    templateUrl: './theme-configuration.component.html',
    styleUrls: ['./theme-configuration.component.scss']
})
export class ThemeConfigurationComponent implements OnInit {
    _globals = GlobalService
    themeList: any[] = [];
    selectedTheme = null;
    isShow: boolean = true;
    confguration = null;
    displayConfirmContinueDialog: boolean = false;
    showConfirmation: boolean = false

    constructor(
        public _abd: AppBaseDataService,
        public _businessSetup: BusinessSetupService,
        public _userService: UserService,
        private _router: Router,
        private _connMessageService: ConnMessageService,
        public _locationService: LocationsService,
        private _location: Location,
        private _confirmationService: ConfirmationService,
    ) { }

    ngOnInit(): void {
        if (Array.isArray(this._globals.webStoreConfiguration)) {
        console.log('Web Store Configuration:', this._globals.webStoreConfiguration);
            this.selectedTheme = this._globals.webStoreConfiguration.filter(v => v.isDefault === true)[0];
        }
    }

    setTheme(type: any, value?: any) {
        if (value.isAvailable) {
            if (type === 'use') {
                this.selectedTheme = value
                this.showConfirmation = true

            } else if (type === 'preview') {
                this._businessSetup.selectedTheme = value
                this._router.navigate(['template-preview'])

            }

        }
    }
    continueButtonClicked() {
        this.displayConfirmContinueDialog = false
    }
    getThemeConfiguration() {
        try {
            this._abd.showSpinner()
            this._businessSetup.getThemeConfigSettings().subscribe(res => {
                if (res.success) {
                    this.themeList = res.data
                    this._abd.hideSpinner()
                }
            })
        }
        catch {
            this._abd.hideSpinner()
        }
    }
    saveFn(currentTemplate?: any) {

        let obj = {
            id: currentTemplate?.id,
            templateID: currentTemplate?.templateID,
            webStoreHost: currentTemplate?.webStoreHost,
            demoUrl: currentTemplate?.demoUrl,
            isDefault: true,
            isAvailable: currentTemplate?.isAvailable,
            imageUrl: currentTemplate?.imageUrl,
            isSelectedLater: currentTemplate?.isSelectedLater,
            createdDate: currentTemplate?.createdDate,
        }
        this._abd.showSpinner()
        this._businessSetup.saveThemeInformation(obj).subscribe(res => {

            if (res.data === true) {
                this._businessSetup.getThemeConfigSettings().subscribe((res) => {
                    if (res.success) {
                        // this._globals.webStoreConfiguration = res.data;
                        this.displayConfirmContinueDialog = true
                        this.confguration = res.data
                    }
                })
                this._connMessageService.showToastMessage(`Theme Configuration saved successfully!`, 'success')
            } else {
                this._connMessageService.showToastMessage(`This template is not available. Please choose another one.`, 'error')
            }
        })

        try {

        }
        catch {
            this._connMessageService.showToastMessage(`Error saving Theme settings!`, 'error')
            this._abd.hideSpinner()
        }

    }

    closeModal(): void {
        this.showConfirmation = false
    }

    confirmTheme(): void {
        let value = this.selectedTheme;
        this.showConfirmation = false
        this.saveFn(value)
    }

    confirmWebsite(): void {
        this.displayConfirmContinueDialog = false
        window.open(this.confguration?.webStoreHost, '_blank');
        let x = window.location.origin + '/#'
        localStorage.setItem('goto', x)
        this._userService.autologin(false)
    }

    confirmEditor(): void {
        this.displayConfirmContinueDialog = false
        window.open(this.confguration?.demoUrl, '_blank');
        let x = window.location.origin + '/#'
        localStorage.setItem('goto', x)
        this._userService.autologin(false)
    }

    back() {
        this._location.back()

    }
}

